<template>
  <div style="width: 100%;height: 100%;display: table;">
    <div @click="titleClick" :style="{cursor:showCursor(),width:width,heigth:height,fontSize:fontSize,fontFamily:chartConfig.fontFamily,color:chartConfig.color,
    textAlign:align,verticalAlign:valign,letterSpacing:letterSpacing,fontWeight:chartConfig.fontWeight,background:chartConfig.background,
    borderLeft:chartConfig.borderLeft,borderRight:chartConfig.borderRight,borderBottom:chartConfig.borderBottom,borderTop:chartConfig.borderTop}" style="display: table-cell;">
        {{chartConfig.title}}
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      chartConfig: {
				type: Object,
				default: function(){
          return {
          fontSize:24,
          fontFamily:'微软雅黑',
          name:'标准标题',
          title:'标准标题',
          color:'#fff',
          background:'rgba(0,0,0,0)',
          align:'center',
          verticalAlign:'middle',
          letterSpacing:8,
          fontWeight:'normal',
          border:'none',
          borderLeft:'none',
          borderRight:'none',
          borderTop:'none',
          borderBottom:'none',
        }
        }
			}
    },
    computed:{

      letterSpacing(){
        return this.chartConfig.letterSpacing+"px"
      },
      fontSize(){
        return this.chartConfig.fontSize+"px"
      },
      align(){
        if(!this.chartConfig.align){
          return 'left'
        }
        return this.chartConfig.align
      },
      valign(){
        if(!this.chartConfig.verticalAlign){
          return 'middle'
        }
        return this.chartConfig.verticalAlign
      }
    },
    data() {
      return {
       }
    },
    methods:{
      showCursor(){
        if(this.chartConfig.locationAddress){
          return "pointer"
        }
        return "default"
      },
      titleClick(){
        console.info("this.chartConfig.locationAddress==="+this.chartConfig.locationAddress)
        if(this.chartConfig.locationAddress){
            //window.location.href=this.chartConfig.locationAddress
        }
      }
    }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/Title.vue